import Input from '@mui/material/Input'; // standard (material)
import { styled } from '@mui/material/styles';
import styledCmp from 'styled-components';
// import Input from '@mui/material/FilledInput';
// import Input from '@mui/material/OutlinedInput';

export const MaterialInput = styled(Input)(
  ({
    theme,
    transparent,
    white,
    height,
    small,
    padding,
    noPadding,
    width,
    required,
    multiline = true,
    maxRows,
  }) => ({
    backgroundColor: transparent
      ? 'transparent'
      : white
        ? theme.palette.colors.white
        : theme.palette.colors.backgroundgrey,
    height: small ? 40 : height ? height : 48,
    borderRadius: 4,
    padding: padding ? '8px' : noPadding ? '0px' : '0 8px',
    resize: 'none',
    border: '1px solid',
    marginTop: padding && '16px',
    width: width ? width : '100%',
    min: 0,
    borderColor: required
      ? theme.palette.colors.required
      : theme.palette.colors.shadow,
    multiline: multiline,
    maxRows: maxRows,

    '&:focus': {
      outline: 'none',
    },
  })
);

export const InputIcon = styledCmp.img.attrs({})`
`;
